import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';

import cl from "./Add.module.css"
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal'
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
// import { selectStyle } from './selectStyle';
import { Link } from 'react-router-dom'; 
import AddClientForm from '../ClientForm/ClientForm';
import { validatePhoneNumber } from '../../../../utils/phone';
import Sale from '../Sale/Sale'

const Add = ({ BookingService, BookingDetailsService, defaultBooking }) => {

    const initBookingModel = (Booking) => {
        return {
            id: 0,
            Booking_id:"0",
            seller_id: 0,
            status_id: 0,
            user_id: 0,

            sender_country_id: 0,
            sender_city_id: 0,
            reciever_country_id: 0,
            reciever_city_id: 0,
            type_id: 0, // Select transportation id
            created_at: '',
            updated_at: '',
            message: '',
            description: '',

            marine_subtype_id: 0,
            icoterm_id: 0,
            land_subtype_id: 0,
            railway_subtype_id: 0,
            marine_line_id:0,
            period_start_at: '',
            period_end_at: '',

            driver_id: '',
            driver_name: '',
            driver_surname: '',
            driver_phone: '',
            driver_car: '',
            custom_id: 0,

            issued_price: 0,
        }
    }

    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
      ];
      
    const marineSubtype = [
    { value: 0, label: ' ' },
    { value: 1, label: 'FCL' },
    { value: 2, label: 'LCL' },
    { value: 3, label: 'Oversized' },
    ];
    
    const landSubtype = [
    { value: 0, label: ' ' },
    { value: 1, label: 'FTL' },
    { value: 2, label: 'LTL' },
    { value: 3, label: 'FCL' },
    { value: 4, label: 'Oversized' },
    ];
    
    const railwaySubtype = [
    { value: 0, label: ' ' },
    { value: 1, label: 'FCL' },
    { value: 2, label: 'LCL' },
    { value: 3, label: 'Wagon' },
    { value: 4, label: 'Cistern' },
    { value: 5, label: 'Oversized' },
    ];
    
    const incotermTypes = [
    { value: 0, label: ' ' },
    { value: 1, label: 'FOB' },
    { value: 2, label: 'FCA' },
    { value: 3, label: 'ExW' },
    { value: 4, label: 'DAP' },
    { value: 5, label: 'CIF' },
    ];
      
    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'გაუქმებული' },
        { value: 2, label: 'გზაში' },
        { value: 3, label: 'დასრულებული' },
        { value: 4, label: 'მიმდინარე' },
    ];

    const customsTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'იმპორტი' },
        { value: 2, label: 'ექსპორტი' },
        { value: 3, label: 'ტრანზიტი' },
        { value: 4, label: 'რეექსპორტი' },
    ];

    const initSaleModel = () => {
        return {
            container_id: 0,
            bl_id: 0,
            service_id: 0,
            marine_line_id: 0,
            bill_of_landing: "",
            amount: 0,
            unit: 0,
            agent_price: 0,
            agent_invoice: "",
            client_price: 0,
            client_invoice: ""
        }
    }
    const { appState, app } = useContext(AppContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newBooking, setNewBooking] = useState(initBookingModel(null))
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const [validates, setValidates] = useState({})
    const [textValue, setTextValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));
    const [salesData, setSalesData] = useState([{ id: 1, data: initSaleModel() }]);
    const [typeId, setTypeId] = useState(0)
    
    const handleTypeIdChange = (selectedOption) => {
        setTypeId(selectedOption.value)
        setNewBooking(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleLandSubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleStatusTypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            status_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleCustomsChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            custom_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setTextValue(newValue);
    
        setNewBooking(prevPrice => ({
            ...prevPrice,
            message: newValue
        }));
    };

    const handleDescriptionChange = (e) => {
        const newValue = e.target.value;
        setDescriptionValue(newValue);
    
        setNewBooking(prevPrice => ({
            ...prevPrice,
            description: newValue
        }));
    };

    const addSale = () => {
        const newId = salesData.length + 1;
        setSalesData([...salesData, { id: newId, data: initSaleModel() }]);
    };

    const removeSale = (id) => {
        setSalesData(salesData.filter((sale) => sale.id !== id));
    };

    const updateSaleData = (id, newData) => {
        setSalesData(prev => prev.map(sale => 
            sale.id === id ? { ...sale, data: newData } : sale
        ));
    };

    const openAdd = () => {
        setNewBooking(initBookingModel(null))
        setIsModalOpen(true)
    }

    const saveHandle = async () => {
    const isValidate = validateBooking(newBooking)

    if (!isValidate) {
        console.log("Validation failed");
        return;
    }

    try {
        // 1) create the booking
        const bookingData = {
        ...newBooking,
        seller_id: appState.user.id,
        user_id: newBooking.client.id,
        created_at: new Date().toLocaleString(),
        };
        const bookingResponse = await BookingService.add(bookingData);
        const bookingId = bookingResponse.id;

        // 2) for each sale: add record, then upload BL & Agent Invoice
        await Promise.all(
        salesData.map(async (sale) => {
            // create sale row
            const createdSale = await BookingDetailsService.add({
            ...sale.data,
            booking_id: bookingId,
            });

            // a) Bill of Lading
            const blFile = sale.data.getUploadFile?.();
            if (blFile) {
            const blForm = new FormData();
            blForm.append('booking_details_id', createdSale.id);
            blForm.append('bill_of_landing', blFile);
            await BookingDetailsService.uploadBillOfLanding(blForm);
            }

            // b) Agent Invoice
            const agentFile = sale.data.getUploadAgentFile?.();
            if (agentFile) {
                const aiForm = new FormData();
                aiForm.append('booking_details_id', createdSale.id);
                aiForm.append('agent_invoice', agentFile);
                await BookingDetailsService.uploadAgentInvoice(aiForm);
            }

            return createdSale;
        })
        );

        // 3) reset form
        setIsModalOpen(false);
        setNewBooking(initBookingModel(null));
        setSalesData([{ id: 1, data: initSaleModel() }]);
    } catch (error) {
        console.error("Error saving booking and sales:", error);
    }
    };

    const validateBooking = (Booking) => {
        const messages = {};

        // Client validation (handled in AddClientForm)
        if (Booking.client_id === 0) {
            if (!Booking.client.firstname || Booking.client.firstname.length < 2) {
                messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
            }
            if (!Booking.client.lastname || Booking.client.lastname.length < 2) {
                messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
            }
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            if (!Booking.client.email || Booking.client.email.length < 2 || !emailRegex.test(Booking.client.email)) {
                messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
            }
            if (!Booking.client.mobile || !validatePhoneNumber(Booking.client.mobile)) {                
                messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
            }  
        }

        // Sender validation
        if (Booking.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Receiver validation
        if (Booking.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Customs type validation
        if (Booking.custom_id < 1) {
            messages.custom_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Status validation
        if (Booking.status_id < 1) {
            messages.status_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Transport type validation
        if (Booking.type_id < 1) {
            messages.type_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Subtype validation based on transport type
        if (Booking.type_id === 1 && Booking.marine_subtype_id < 1) {
            messages.marine_subtype_id = { message: 'სავალდებულოა', isValid: false };
        } else if (Booking.type_id === 2 && Booking.land_subtype_id < 1) {
            messages.land_subtype_id = { message: 'სავალდებულოა', isValid: false };
        } else if (Booking.type_id === 3 && Booking.railway_subtype_id < 1) {
            messages.railway_subtype_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Incoterm validation
        if (Booking.icoterm_id < 1) {
            messages.icoterm_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Marine line validation
        if (Booking.marine_line_id < 1) {
            messages.marine_line_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Driver fields validation for land transport
        if (Booking.type_id === 2) {
            if (!Booking.driver_id || Booking.driver_id.length < 1) {
                messages.driver_id = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_name || Booking.driver_name.length < 2) {
                messages.driver_name = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_surname || Booking.driver_surname.length < 2) {
                messages.driver_surname = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_phone || !validatePhoneNumber(Booking.driver_phone)) {
                messages.driver_phone = { message: 'არასწორი ნომერი', isValid: false };
            }
            if (!Booking.driver_car || Booking.driver_car.length < 2) {
                messages.driver_car = { message: 'სავალდებულოა', isValid: false };
            }
        }

        // Sales validation
        if (salesData.length === 0) {
            messages.sales = { message: 'მინიმუმ ერთი სეილი სავალდებულოა', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const selectStyle = {
        control: (provided) => ({
            ...provided,
            minHeight: '35px',
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
            position: 'relative',
            zIndex: 2
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'relative'
        }),
        menuPortal: base => ({
            ...base,
            zIndex: 9999
        })
    };

const getErrorStyle = (fieldName) => {
  const hasError = validates && validates[fieldName];

  return {
    ...selectStyle,
    control: (provided, state) => ({
      ...provided,
      border: hasError ? '1px solid rgb(225, 29, 72)' : provided.border,
      '&:hover': {
        border: hasError ? '1px solid rgb(225, 29, 72)' : provided.border,
      },
      minHeight: '35px',
      width: '100%',
      cursor: 'pointer',
      borderRadius: '5px',
      zIndex: 2
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    })
  };
};


    const getInputErrorClass = (fieldName) => {
        return validates && validates[fieldName] ? cl.error : '';
    };

    const getTextareaErrorStyle = (fieldName) => {
        return validates && validates[fieldName] ? {
            border: '1px solid rgb(225 29 72)',
            borderRadius: '6px',
            padding: '8px'
        } : {
            border: '1px solid grey',
            borderRadius: '6px',
            padding: '8px'
        };
    };

    return(
        <div>
            <span className={cl.AddBtn} onClick={() => openAdd()} >
                <span className={cl.icon} > <Plus /></span>
                დამატება
            </span>

            <Modal size="xl" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> დამატება</h3>
                </div>

                <AddClientForm newBooking={newBooking} setNewBooking={setNewBooking} validates={validates}></AddClientForm>

                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.sender_country_id}
                        childId={newBooking.sender_city_id}
                        isNetwork={true}
                        styles={getErrorStyle('sender_country_id')}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={typeId == 2 ? "ქვეყანა" : "პორტი"}
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                        menuPortalTarget={document.body}
                    />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.reciever_country_id}
                        childId={newBooking.reciever_city_id}
                        isNetwork={true}
                        styles={getErrorStyle('reciever_country_id')}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={typeId == 2 ? "ქვეყანა" : "პორტი"}
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                        menuPortalTarget={document.body}
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საბაჟოს ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('custom_id')}
                            options={customsTypeOptions}
                            value={customsTypeOptions.find(option => option.value === newBooking.custom_id)}
                            onChange={handleCustomsChange}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.custom_id && <span className={cl.errorMessage}>{validates.custom_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('status_id')}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newBooking.status_id)}
                            onChange={handleStatusTypeChange}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.status_id && <span className={cl.errorMessage}>{validates.status_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('type_id')}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newBooking.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.type_id && <span className={cl.errorMessage}>{validates.type_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {typeId == 2 && (
                    <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_id')}`}
                                    value={newBooking.driver_id || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_id: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის პ/ნ"
                                />
                                {validates?.driver_id && <span className={cl.errorMessage}>{validates.driver_id.message}</span>}
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_name')}`}
                                    value={newBooking.driver_name || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_name: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის სახელი"
                                />
                                {validates?.driver_name && <span className={cl.errorMessage}>{validates.driver_name.message}</span>}
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_surname')}`}
                                    value={newBooking.driver_surname || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_surname: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის გვარი"
                                />
                                {validates?.driver_surname && <span className={cl.errorMessage}>{validates.driver_surname.message}</span>}
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_phone')}`}
                                    value={newBooking.driver_phone || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_phone: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის ტელეფონი"
                                />
                                {validates?.driver_phone && <span className={cl.errorMessage}>{validates.driver_phone.message}</span>}
                            </div>
                            </div>
                            <div style={{ width: "80%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_car')}`}
                                    value={newBooking.driver_car || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_car: e.target.value
                                        }));
                                    }}
                                    placeholder="სატრ.საშუალების ნომერი"
                                />
                                {validates?.driver_car && <span className={cl.errorMessage}>{validates.driver_car.message}</span>}
                            </div>
                    </fieldset>
                )}

                {newBooking.type_id === 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('marine_subtype_id')}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newBooking.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.marine_subtype_id && <span className={cl.errorMessage}>{validates.marine_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('land_subtype_id')}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newBooking.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.land_subtype_id && <span className={cl.errorMessage}>{validates.land_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 3 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('railway_subtype_id')}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newBooking.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.railway_subtype_id && <span className={cl.errorMessage}>{validates.railway_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}

                {
                    typeId == 2 ? 
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>აგენტი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={getErrorStyle('marine_line_id')}
                                    options={agents}
                                    value={agents.find(option => option.value === newBooking.marine_line_id)}
                                    onChange={(selectedOption) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            marine_line_id: selectedOption ? selectedOption.value : 0,
                                        }));

                                        if (selectedOption) {
                                            setNewBooking(prevState => ({
                                                ...prevState,
                                            }));
                                        } else {
                                            setTypeOptions(initialTypeOptions);
                                        }
                                    }}
                                    placeholder="აგენტი"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                />
                                {validates?.marine_line_id && <span className={cl.errorMessage}>{validates.marine_line_id.message}</span>}
                            </div>
                        </fieldset> 
                :
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>საზღვაო ხაზი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={getErrorStyle('marine_line_id')}
                                    options={marines}
                                    value={marines.find(option => option.value === newBooking.marine_line_id)}
                                    onChange={(selectedOption) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            marine_line_id: selectedOption ? selectedOption.value : 0,
                                        }));

                                        if (selectedOption) {
                                            setNewBooking(prevState => ({
                                                ...prevState,
                                            }));
                                        } else {
                                            setTypeOptions(initialTypeOptions);
                                        }
                                    }}
                                    placeholder="საზღვაო ხაზი"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                />
                                {validates?.marine_line_id && <span className={cl.errorMessage}>{validates.marine_line_id.message}</span>}
                            </div>
                        </fieldset>
                }


                <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                    <div style={{ width: "50%" }}>
                        <input
                            type="number"
                            className={`${cl.input} ${getInputErrorClass('issued_price')}`}
                            value={newBooking.issued_price || 0}
                            onChange={(e) => {
                                setNewBooking(prevState => ({
                                    ...prevState,
                                    issued_price: parseInt(e.target.value)
                                }));
                            }}
                            placeholder="გაცემული ფასი"
                        />
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="message"
                        value={textValue}
                        onChange={handleTextChange}
                        rows={4}
                        cols={100}
                        style={getTextareaErrorStyle('message')}
                        placeholder="კომენტარი"
                    />
                    {validates?.message && <span className={cl.errorMessage}>{validates.message.message}</span>}
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="description"
                        value={descriptionValue}
                        onChange={handleDescriptionChange}
                        rows={4}
                        cols={100}
                        style={getTextareaErrorStyle('description')}
                        placeholder="Description"
                    />
                    {validates?.description && <span className={cl.errorMessage}>{validates.description.message}</span>}
                </fieldset>

                <h2 style={{ textAlign: 'center' }}>SALE</h2>
                    <button onClick={addSale} className={cl.btnPrimary}>სეილის დამატება</button>
                    <h4>მომსახურების ღირებულება</h4>
                    <div>
                        {salesData.map(sale => (
                        <div key={sale.id}>
                            <Sale
                            id={sale.id}
                            saleData={sale.data}
                            onUpdate={updateSaleData}
                            isUpdate={false}
                            booking={newBooking}
                            />
                            <button
                            className={cl.btnPrimary}
                            style={{ backgroundColor: 'rgb(255, 68, 68)' }}
                            onClick={() => removeSale(sale.id)}
                            >
                            Remove
                            </button>
                        </div>
                        ))}
                </div>

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>
            </Modal>
        </div>
    )
}

export default Add;